"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _workspaces = _interopRequireDefault(require("./workspaces"));

var _teams = _interopRequireDefault(require("./teams"));

var _users = _interopRequireDefault(require("./users"));

var _workspacesAudits = _interopRequireDefault(require("./workspacesAudits"));

var _redux = require("redux");

var _default = (0, _redux.combineReducers)({
  workspaces: _workspaces.default,
  teams: _teams.default,
  users: _users.default,
  workspacesAudits: _workspacesAudits.default
});

exports.default = _default;
module.exports = exports.default;